import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LoadingModule } from '../loading/loading.module';
import { MaterialModule } from '../material/material.module';
import { Pages } from '../pages.config';
import { CenterlineGroupSelectionComponent } from './centerline-group-selection/centerline-group-selection.component';
import { CenterlineSelectionComponent } from './centerline-selection/centerline-selection.component';
import { LocationContextEffects } from './store/location-context.effects';
import * as fromLocationContext from './store/location-context.reducers';
import { TerminalSelectionComponent } from './terminal-selection/terminal-selection.component';

const locationContextRoutes: Routes = [
    {
        path: '',
        component: TerminalSelectionComponent
    },
    {
        path: Pages.locationContext_CenterlineGroup.path,
        component: CenterlineGroupSelectionComponent
    },
    {
        path: Pages.locationContext_Centerline.path,
        component: CenterlineSelectionComponent
    }
];

@NgModule({
    declarations: [TerminalSelectionComponent, CenterlineGroupSelectionComponent, CenterlineSelectionComponent],
    imports: [
        CommonModule,
        MaterialModule,
        LoadingModule,
        RouterModule.forChild(locationContextRoutes),
        StoreModule.forFeature(fromLocationContext.locationContextFeatureKey, fromLocationContext.terminalsReducer, {
            metaReducers: fromLocationContext.metaReducers
        }),
        EffectsModule.forFeature([LocationContextEffects])
    ]
})
export class LocationContextModule {}
